import React, { useState } from "react";
import PropTypes from "prop-types";
import dynamic from "next/dynamic";
import useDeviceKind from "@gcloud-npm/utils.common.get-device-kind-depends-on-viewport";
import style from "./style";
import { grid, colors } from "../constants";

const Image = dynamic(() => import("@/bit/components/components.c-image"));
const Video = dynamic(() => import("./video"));

const Background = ({ videoMP4, videoWebM, image, alt, playVideo }) => {
  const device = useDeviceKind();

  return (
    <>
      <div className="backround" data-cy="Ecosystem Backround">
        {device === "BIG_DESKTOP" || device === "DESKTOP" ? (
          <Video
            videoMP4={videoMP4}
            videoWebM={videoWebM}
            alt={alt}
            backupImage={image}
            playVideo={playVideo}
          />
        ) : (
          <Image
            src={image}
            className="image"
            alt="background-image-experiencia-movistar"
            fill
            objectFit="cover"
            cyData="Ecosystem Backround Image"
          />
        )}
        <div className="linear-gradient"></div>
      </div>
      <style jsx>{style}</style>
    </>
  );
};

Background.propTypes = {};
Background.defaultProps = {};

export default Background;
